import BOTTOM_SHEETS from 'components/bottomsheet/registry';
import { BottomSheet } from 'components/common/BottomSheet';
import useBottomSheet from 'hooks/common/useBottomSheet';

function BottomSheetRouter() {
  const { sheets } = useBottomSheet();

  return (
    <>
      {Object.keys(sheets).map((id) => {
        const sheet = sheets[id];
        const Content = BOTTOM_SHEETS[id];
        if (sheet.status === 'idle' || !Content) {
          return null;
        }

        const mergedOptions = { ...sheet.options, ...Content.options };
        const Component = Content.content;

        return (
          <BottomSheet key={id} id={id} sheet={{ ...sheet, options: mergedOptions }}>
            <Component />
          </BottomSheet>
        );
      })}
    </>
  );
}

export default BottomSheetRouter;
